import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { GestaoFuncionariosComponent } from './gestao-funcionarios.component';
import { DemissaoFuncionariosComponent } from './demissao-funcionario/demissao-funcionarios.component';
import { CadastroFuncionarioComponent } from './funcionario/cadastro-funcionario/cadastro-funcionario.component';
import { CadastroVincularProdutoComponent } from './funcionario/vincular-produto/cadastro-vincular-produto/cadastro-vincular-produto.component';
import { ListarVinculoProdutoComponent } from './funcionario/vincular-produto/listar-vinculo-produto/listar-vinculo-produto.component';
import { ListaAlteracaoStatusComponent } from './alteracao-status/lista-alteracao-status/lista-alteracao-status.component';
import { ListaAlteracaoLimiteComponent } from './alteracao-limite/lista-alteracao-limite/lista-alteracao-limite.component';
import { ListaFuncionarioComponent } from './funcionario/lista-funcionario/lista-funcionario.component';
import { ImportacaoFuncionariosComponent } from './funcionario/importacao/importacao-funcionarios/importacao-funcionarios.component';
import { ConsultaArquivosImportacaoFuncionariosComponent } from './funcionario/importacao/consulta-arquivos-importacao-funcionarios/consulta-arquivos-importacao-funcionarios.component';
import { ConsultaImportacaoFuncionariosComponent } from './funcionario/importacao/consulta-importacao-funcionarios/consulta-importacao-funcionarios.component';
import { AuthGuardService } from '../../shared/filters/auth-guard.service';
import { ConsultarFuncionarioComponent } from './funcionario/consultar-funcionario/consultar-funcionario.component';
import { VisualizarFuncionarioComponent } from './funcionario/visualizar-funcionario/visualizar-funcionario.component';
import { ImportarArquivoFuncionarioComponent } from './funcionario/importacao/importar-arquivo-funcionario/importar-arquivo-funcionario.component';
import { HistoricoImportacaoFuncionarioComponent } from '../../shared/importacao-funcionario-lote/pages/historico-importacao-funcionario/historico-importacao-funcionario.component';
import { ImportacaoFinalizadaComponent } from '../../shared/importacao-funcionario-lote/pages/importacao-finalizada/importacao-finalizada.component';
import { ValidarPagamentoCartaoComponent } from '../../shared/importacao-funcionario-lote/pages/validar-pagamento-cartao/validar-pagamento-cartao.component';
import { ValidarImportacaoComponent } from '../../shared/importacao-funcionario-lote/pages/validar-importacao/validar-importacao.component';
import { DistribuicaoSaldoComponent } from '../../shared/importacao-funcionario-lote/pages/distribuicao-saldo/distribuicao-saldo.component';
import { ImportarArquivoFuncionarioLoteComponent } from '../../shared/importacao-funcionario-lote/pages/importar-arquivo-funcionario-lote/importar-arquivo-funcionario-lote.component';
import { MigrarFuncionariosComponent } from './funcionario/rollout-funcionario/pages/migrar-funcionarios/migrar-funcionarios.component';
import { AcompanharMigracoesComponent } from './funcionario/rollout-funcionario/pages/acompanhar-migracoes/acompanhar-migracoes.component';


const routes: Routes = [{
  path: '',
  component: GestaoFuncionariosComponent,
  children: [
    {
      path: 'demissao-funcionarios',
      component: DemissaoFuncionariosComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['DEMITIR_FUNCIONARIO'] }
    },
    {
      path: 'cadastro-funcionario',
      component: CadastroFuncionarioComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['CADASTRAR_FUNCIONARIO'] }
    },
    {
      path: 'consultar-funcionario',
      component: ConsultarFuncionarioComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['CONSULTAR_FUNCIONARIOS'] }
    },
    {
      path: 'visualizar-funcionario',
      component: VisualizarFuncionarioComponent,
    },
    {
      path: 'cadastro-vincular-produto',
      component: CadastroVincularProdutoComponent,
    },
    {
      path: 'cadastro-vincular-produto/:id',
      component: CadastroVincularProdutoComponent,
    },
    {
      path: 'listar-vinculo-produto',
      component: ListarVinculoProdutoComponent,
    },
    {
      path: 'editar-vincular-produto/:id',
      component: ListarVinculoProdutoComponent,
    },
    {
      path: 'lista-alteracao-status',
      component: ListaAlteracaoStatusComponent,
    },
    {
      path: 'lista-alteracao-limite',
      component: ListaAlteracaoLimiteComponent,
    },
    {
      path: 'lista-funcionario',
      component: ListaFuncionarioComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['CADASTRAR_FUNCIONARIO'] }
    },
    {
      path: 'importacao-funcionarios',
      component: ImportacaoFuncionariosComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['IMPORTAR_ARQUIVO_LOTE'] }
    },
    {
      path: 'consulta-arquivos-importacao-funcionarios',
      component: ConsultaArquivosImportacaoFuncionariosComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['ACOMPANHAR_IMPORTACAO_LOTE'] }
    },
    {
      path: 'consulta-importacao-funcionarios',
      component: ConsultaImportacaoFuncionariosComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['ACOMPANHAR_IMPORTACAO_LOTE'] }
    },
    {
      path: 'importar-arquivo-funcionario',
      component: ImportarArquivoFuncionarioComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['CADASTRO_FUNCIONARIO_1VIA'] }
    },
    {
      path: 'importacao-lote',
      component: HistoricoImportacaoFuncionarioComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['IMPORTAR_LOTE_FUNCIONARIO'] }
    },
    {
      path: 'importar-arquivo',
      component: ImportarArquivoFuncionarioLoteComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['IMPORTAR_LOTE_FUNCIONARIO'] }
    },
    {
      path: 'validar-importacao',
      component: ValidarImportacaoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['IMPORTAR_LOTE_FUNCIONARIO'] }
    },
    {
      path: 'validar-pagamento-cartao',
      component: ValidarPagamentoCartaoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['IMPORTAR_LOTE_FUNCIONARIO'] }
    },
    {
      path: 'distribuicao-saldo',
      component: DistribuicaoSaldoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['IMPORTAR_LOTE_FUNCIONARIO'] },
    },
    {
      path: 'importacao-finalizada',
      component: ImportacaoFinalizadaComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['IMPORTAR_LOTE_FUNCIONARIO'] }
    },
    {
      path: 'migrar-funcionarios',
      component: MigrarFuncionariosComponent,
    },
    {
      path: 'acompanhar-migracoes',
      component: AcompanharMigracoesComponent,
    }

  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})
export class GestaoFuncionariosRoutingModule { }

export const routedComponents = [
  GestaoFuncionariosComponent,
  DemissaoFuncionariosComponent,
  CadastroFuncionarioComponent,
  CadastroVincularProdutoComponent,
  ListarVinculoProdutoComponent,
  ListaAlteracaoLimiteComponent,
  ListaAlteracaoStatusComponent,
  ConsultarFuncionarioComponent,
  VisualizarFuncionarioComponent,
  ImportarArquivoFuncionarioComponent
];
